<div class="PolicyDashboard">
        <div class="Loading"  *ngIf="isShowLoading==true">
                <img id="" src="assets/img/762.gif"   />
                <label>{{'Please Wait,Processing..'|translate }}</label>
        </div>
    
        <div class="container-fluid">
    
            <div class="row">

                    <div class="col-lg-2 col-md-2 hidden-sm hidden-xs"></div>
                    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">

                            <div class="col-md-12 proposals">
    
                                    <div class="panel panel-default panel-table">
                                        <div class="panel-heading">
                                            <div class="row">
                                                <div class="col col-xs-6">
                                                    <h3 class="panel-title">{{'Renewal Policy'|translate }}</h3>
                                                </div>
                                                <!-- <div class="col col-xs-6 text-right">
                                            <button type="button" class="btn btn-sm btn-primary btn-create">Create New</button>
                                          </div> -->
                                            </div>
                                        </div>
                                        <div class="panel-body">
                    
                                            <div class="PaymentForm">
                    
                    
                                                <div class="row">
                                                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-5 arabicfieldarrange">
                                                        <label>{{'PolicyNo' | translate }}</label>
                                                    </div>
                                                    <div class="col-lg-9 col-md-9 col-sm-9 col-xs-7">
                                                        <input type="text" class="form-control" [disabled]="true" name="txtPolicyNo" id="txtPolicyNo" [(ngModel)]="renewObj.PolicyNo">
                                                    </div>
                                                </div>
                    
                                                <div class="row">
                                                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-5 arabicfieldarrange">
                                                        <label>{{'Name' | translate }}</label>
                                                    </div>
                                                    <div class="col-lg-9 col-md-9 col-sm-9 col-xs-7">
                                                        <input type="text" class="form-control" [disabled]="true" name="txtName" id="txtName" [(ngModel)]="renewObj.InsName">
                                                    </div>
                                                </div>
                    
                                                <div class="row">
                                                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-5 arabicfieldarrange">
                                                        <label>{{'Iqama/ID No' | translate }}</label>
                                                    </div>
                                                    <div class="col-lg-9 col-md-9 col-sm-9 col-xs-7">
                                                        <input type="text" class="form-control" [disabled]="true" name="txtIqama" id="txtIqama" [(ngModel)]="renewObj.IqamaNoforDis">
                                                    </div>
                                                </div>
                    
                                                <div class="row">
                                                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-5 arabicfieldarrange">
                                                            <label>{{'Sequence No' | translate }}</label>
                                                        </div>
                                                        <div class="col-lg-9 col-md-9 col-sm-9 col-xs-7">
                                                            <input type="text" class="form-control" [disabled]="renewObj.Vdtype=='2'" required name="txtSeq" id="txtSeq" [(ngModel)]="renewObj.SequenceNo" #txtSeq>
                                                            <span *ngIf="txtSeq.invalid && (txtSeq.dirty || txtSeq.touched)" class="text-danger valid">
                                                                    <div *ngIf="txtSeq.errors?.required">
                                                                            {{ 'Sequence Number is required'| translate}}
                                                                    </div>                                           
                                
                                                                </span>
                                                        </div>

                                                    </div>
                                                 
                <!--(click)="goCancel()"-->
                                                <div class="row">
                                                        <div class="col-sm-4"></div>
                                                    <div class="PayButton  col-sm-4">
                                                        <button class="btn btn-primary btn-block" [disabled]="renewObj.SequenceNo==''" name="btnProceed" id="btnProceed" (click)="proceedToRenew()" >{{'Renew Policy' | translate }}</button>
                                                    </div>
                                                    <div class="PayButton cancelrenew col-sm-4">
                                                        <button class="btn btn-primary btn-block" name="btnCancel" id="btnCancel"  (click)="Cancel()">{{'Cancel' | translate }}</button>
                                                    </div>
                                                </div>
                    
                                            </div>
                    
                    
                    
                                        </div>
                    
                    
                                    </div>
                    
                                </div>
                        </div>

                        <div class="col-lg-2 col-md-2 hidden-sm hidden-xs"></div>
               
    
            </div>
        </div>
    
    </div>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MotorPortal/RenewalPolicy/RenewalPolicy.html